// extracted by mini-css-extract-plugin
module.exports = {"layout":"flipflop_layout__QArVv","image":"flipflop_image__MNXOV","body":"flipflop_body__foZ_w","flipped":"flipflop_flipped__jAPn7"};